import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import { getMUICache, appendStyleSheet, handleSearchClick, getImageUrl, getLoggedUserName, getLoggedUserEmail,logoutUser, getLoggedInFlag, safeCharAt, fetchAnchorValue } from "../../../common/utils";
import { CacheProvider } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import { Button } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import { Link } from '@mui/material';

import "./OtherMainMenuThree.css";
import "./MainMenuThree.css";
import HomeIcon from '@mui/icons-material/Home';
import { ENDUSER_PAGE } from '../../Common/Constant';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import bcrypt from 'bcryptjs-react';
import { PAGEBUILDER_URLS } from '../../Common/Constant';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal'
import CloseIcon from '@mui/icons-material/Close';


MainMenuThree.version = 1000;

MainMenuThree.lang = 'en';
MainMenuThree.langs = [
  'en'
];
MainMenuThree.setLang = (lang: any) => {
  MainMenuThree.lang = lang;
}

Object.defineProperty(MainMenuThree, 'name', {
  writable: true,
  value: 'MainMenuThree'
});

const style = {
  position: 'absolute' as 'absolute', 
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export default function MainMenuThree(props: any) {
  const { menuItems, domainUrl, toggleMainMenu, headerMenuEndpoint, cdsDomain, L1BgColor, L1TextColor, L2BgColor, L2TextColor, showSearch, pagetype, mainLogo, noOfHeaderItems, hostId, anchorLinksValue } = props;
  const [SearchBar, setSearchBar] = useState<any>(false);
  const [Closebtn, setClosebtn] = useState<any>(false);
  const [isActive, setIsActive] = useState<any>(false);
  //const [headerData] = useState<any>({});
  const [searchValue, setSearchValue] = useState<any>("");
  const [scrolltopdata, setscrolltopdata] = useState('');
  const [loggedUserName, setLoggedUserName] = useState<any>("");
  const [loggedUserEmail, setLoggedUserEmail] = useState<any>("");
  const [loginLink, setLoginLink] = useState<any>();
  const [loginEnabled, setLoginEnabled] = useState(false);

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  // Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // const handleClose = () => {
  //   setOpen(false);
  //   setSearchBar(false);
  // };

  // Modal
  // Add and Remove Class on scroll

  if( !loginEnabled && props && props.transportData && props.transportData.isLoginEnabled ) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }

  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink( "/login?url=" + encodeURIComponent(window.location.href) );
    if( !loginEnabled && props && props.transportData && props.transportData.isLoginEnabled ) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());

    window.addEventListener('scroll', () => {
      if (window.scrollY < 15) {
        setscrolltopdata('');
      } else {
        setscrolltopdata('scrolled');
      }
    });
  }, [])
  // Add and Remove Class on scroll

  let styles1 = require("./MainMenuThree.css");
  let styles2 = require("./OtherMainMenuThree.css");
  
  appendStyleSheet("MainMenuThree", styles1);
  appendStyleSheet("OtherMainMenuThree", styles2);

  // let styles = require("./MainMenuThree.css");
  // appendStyleSheet("MainMenuThree", styles);

  const getUrl = (domainUrl: string, path: string) => {
    if(path && path.startsWith("http")) { return path;}
    if (!domainUrl) { return; }
    let updatedDomain = domainUrl;
    if (domainUrl.length > 0 && domainUrl[domainUrl.length - 1] == "/") {
      updatedDomain = domainUrl.substring(0, domainUrl.length - 1)
    }

    return updatedDomain + path;
  }

  const getSubMenu = (subMenuItems: any) => {
    return <div className="submenuItems HomeSubMainMenu" style={{ backgroundColor: L2BgColor }}>
      {
        subMenuItems.map((subMenuItem: any, index: number) => {
          let submenuPath = subMenuItem.path;
          if (subMenuItem.type === 2) {
            submenuPath = '/tags/' + (subMenuItem.tagpath !== undefined ? subMenuItem.tagpath : '');
          }
          return <div className='subMenuli' key={'mmi__' + index} itemProp="name" content={subMenuItem?.name}>
            <a key={'mmia__' + index} href={getUrl(domainUrl, submenuPath)} target={fetchAnchorValue(anchorLinksValue, submenuPath)}  style={{ color: L2TextColor }} itemProp="url" content={getUrl(domainUrl, submenuPath)}>
              {subMenuItem.name}
            </a>
            </div>
        }
        )
      }
    </div>
  }



  const getSubMenu_ROS = (subMenuItems: any) => {
    return <div className='submenitemsWrapper'><div className="submenuItems" style={{ backgroundColor: L2BgColor }}>
      {
        subMenuItems.map((subMenuItem: any, index: number) => {
          let submenuPath = subMenuItem.path;
          if (subMenuItem.type === 2) {
            submenuPath = '/tags/' + (subMenuItem.tagpath !== undefined ? subMenuItem.tagpath : '');
          }
          return <div className='subMenuli' key={'mmi__' + index} itemProp="name" content={subMenuItem.name}>
            <a key={'mmia__' + index} href={getUrl(domainUrl, submenuPath)} target={fetchAnchorValue(anchorLinksValue, submenuPath)} style={{ color: L2TextColor }} itemProp="url" content={getUrl(domainUrl, submenuPath)}>
              {subMenuItem.name}
            </a>
            </div>
        }
        )
      }

    </div>
    </div>

  }

  const showSearchBar = () => {
    setSearchBar(true)
    setClosebtn(true)
  }
  const closehandler = () => {
    // setSearchBar(false)
    // setClosebtn(false)
    setSearchBar(true)
    setClosebtn(true)
  }

  const renderMoreOption = () => {
    let optionData = menuItems?.slice(noOfHeaderItems , menuItems.length);
    return <li className="nav-item hideMoreMobile">
      <ListItemButton key="test" component="a" className="has-submenu" style={{ color: L1TextColor }}>More</ListItemButton> 
      <ul className="submenu" style={{ backgroundColor: L2BgColor }}>
        {optionData.map((menuItem: any, index: number) => {
          let morePath: string = menuItem.path;
          if (menuItem.type === 2) {
            morePath = '/tags/' + (menuItem.tagpath !== undefined ? menuItem.tagpath : '');
          }
          return <li key={index} className='submenu-item ' itemProp="name" content={menuItem.name}>
            <a href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)} style={{ color: L1TextColor }} itemProp="url" content={getUrl(domainUrl, morePath)}>{menuItem.name}</a>
            </li>
        }
        )}
      </ul>
    </li>
  }

  const checkIfActive = (name: string) => {

    if (typeof window !== 'undefined' && window && window.location && window.location.pathname) {
      const pathName = window.location.pathname.toLowerCase();
      const nameLowerCase = name?.toString()?.toLowerCase();

      if (pathName.indexOf("/" + nameLowerCase + "/") >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const getMenuData = () => {
    if (!Array.isArray(menuItems)) {
      console.error('menuItems is not an array or is undefined');
      return [];
    }
    let menuData = menuItems?.slice(0, noOfHeaderItems);
    let moreOption: any;
    if (menuData.length > 0 && menuData.some((item: any) => item?.secid === '123')) {
      if (typeof window !== 'undefined' && window) {
        const { pathname } = window.location;
        const splitPath = pathname.split('/');
        const secondLastSegment = splitPath[splitPath.length - 2];
        if (ENDUSER_PAGE.includes(secondLastSegment)) {
          callNavApi(menuData, headerMenuEndpoint.queryParams.hostId);
          menuData = menuData.map((item: any) => {
            if (item?.secid === '123') {
              return { ...item, name: <HomeIcon />, key: 123 };
            }
            return item;
          });
        }
      }
    }

    let data = menuData.map((menuItem: any, index: number) => {
      if (menuItem) {
        let isActive = checkIfActive(menuItem.name);
        let morePath: string = menuItem.path;
        if (menuItem.type === 2) {
          morePath = '/tags/' + (menuItem.tagpath !== undefined ? menuItem.tagpath : '');
        }

        return <ListItem key={'kk_' + index} className={`menuItem ${isActive ? "active" : ""}`} itemProp="name" content={menuItem.name}>
          <div key={'00_' + index}>
            <a key={'111_' + index} href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)} style={{ color: L1TextColor }} itemProp="url" content={getUrl(domainUrl, morePath)}>{menuItem.name}</a>
            {/* {REQUEST_URL} */}
            {(menuItem.sections && menuItem.sections.length > 0) && getSubMenu(menuItem.sections)}
          </div>
        </ListItem>
      }
    })

    if (menuItems.length > noOfHeaderItems) {
      moreOption = renderMoreOption();
    }

    return [...data, moreOption];
  }

  const getMenuDataROS = () => {
    let menuData = menuItems?.slice(0, 6);
    let moreOption: any;
    // if (menuData.length > 0 && menuData.some((item: any) => item?.secid === '123')) {
    //   if (typeof window !== 'undefined' && window) {
    //     const { pathname } = window.location;
    //     const splitPath = pathname.split('/');
    //     const secondLastSegment = splitPath[splitPath.length - 2];
    //     if (ENDUSER_PAGE.includes(secondLastSegment)) {
    //       callNavApi(menuData, headerMenuEndpoint.queryParams.hostId);
    //       menuData = menuData.map((item: any) => {
    //         if (item?.secid === '123') {
    //           return { ...item, name: <HomeIcon />, key: 123 };
    //         }
    //         return item;
    //       });
    //     }
    //   }
    // }

    let data = menuData.map((menuItem: any, index: number) => {
      if (menuItem) {
        let isActive = checkIfActive(menuItem.name);
        let morePath: string = menuItem.path;
        if (menuItem.type === 2) {
          morePath = '/tags/' + (menuItem.tagpath !== undefined ? menuItem.tagpath : '');
        }

        return <ListItem key={'kk_' + index} className={`menuItem ${isActive ? "active" : ""}`} itemProp="name" content={menuItem.name}>
          <div key={'00_' + index}>
            <a key={'111_' + index} href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)} style={{ color: L1TextColor }} itemProp="url" content={getUrl(domainUrl, morePath)}>
              {menuItem.name}
            </a>

            {(menuItem.sections && menuItem.sections.length > 0) && getSubMenu_ROS(menuItem.sections)}
          </div>
        </ListItem>
      }
    })

    if (menuItems.length > 9) {
      moreOption = renderMoreOption();
    }

    return [...data, moreOption];
  }

  function callNavApi(menuData: any, hostId: any) {
    if (typeof window !== 'undefined' && undefined !== window && window) {
      const pathName = window.location.pathname;
      const pathArray = pathName.split('/');
      let msid = pathArray[pathArray.length - 1];
      msid = msid.split('.')[0];
      const url = `${cdsDomain}/cds-feed-ext/listing/get/m360?msid=${msid}&fv=1000&hostId=${hostId}&pp=4&cp=1&apiType=nav`;

      let headerString = '?' + url.split("?")[1];
      headerString = bcrypt.hashSync(headerString, 6);
      const headers = { 'p-nonce': headerString };

      const fetch1 = require('sync-fetch');
      const pr = fetch1(url, { headers: headers });
      const statusCode = pr.status;
      let response = [];
      try {
        response = pr.json();
      } catch (error: any) {
        console.error('Error:', error.message);
      }
      if (statusCode === 200) {
        if (response) {
          const firstElement = response.items[0];
          let item = null;
          if (pathArray.includes('articleshow')) {
            item = { name: firstElement.hl, secid: '456', path: firstElement.wu, type: 1 }
          } else if (pathArray.includes('articlelist')) {
            item = { name: response.title, secid: '456', path: pathName, type: 1 }
          }
          //menuData.unshift(item);
          menuData.splice(1, 0, item);
        }
      }
    }
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission or new window/popup
      handleSearchClick(searchValue, hostId); // Call your search handling function
    }
  }

  const getLoginString = () => {
    if( loginEnabled ) {
      if (loggedUserName) {
        return (
          <div className="ThemeThreeWelcomeWrapper">
            <button className="ThemeThreeAfterLoginButton">
              <span>{safeCharAt(loggedUserName)}</span>
            </button>
            <ul className="ThemeThreeListLog">
              <li className="ThemeThreeDesktopUserName">
                {loggedUserName}{" "}
                <span className="ThemeThreeDesktopUserEmail">{loggedUserEmail}</span>
              </li>
              {/* <li className="ThemeThreeDesktopUserEmail">{loggedUserEmail}</li> */}
              <li>
                {" "}
                <a onClick={logoutUser} href="javascript:void(0)">
                  Logout
                </a>
              </li>
            </ul>
          </div>
        );
      }
      return (
        <div className="ThemeThreeLoginWrapper">
          <a href={loginLink} className="ThemeThreeLoginAnchor">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z" fill="#F29D38"/>
  <mask id="path-2-inside-1_13_3229" fill="white">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"/>
  </mask>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z" fill="black"/>

  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7865 15.7122C13.052 15.5985 10.8701 13.3457 10.8701 10.5833L10.8746 10.3663C10.9883 7.63192 13.2411 5.45 16.0034 5.45L16.2204 5.4545C18.9549 5.56821 21.1368 7.82096 21.1368 10.5833L21.1323 10.8003C21.0186 13.5347 18.7658 15.7167 16.0034 15.7167L15.7865 15.7122ZM16.1973 14.1114C18.0586 14.0108 19.5368 12.4697 19.5368 10.5833L19.5316 10.3895C19.4309 8.52822 17.8898 7.05 16.0034 7.05L15.8096 7.05523C13.9483 7.15587 12.4701 8.69697 12.4701 10.5833L12.4753 10.7772C12.576 12.6384 14.1171 14.1167 16.0034 14.1167L16.1973 14.1114Z" fill="black"/>
  </svg>

            {/* <span>login</span> */}
          </a>
        </div>
      );
    }
  };
  

  return (
    <CacheProvider value={getMUICache()}>
      <div className={`themeThreeMainMenuWrap ${scrolltopdata}`}>
        <Box sx={{ minHeight: 19 }} className="themeThreeMainMenu">
          <div className='navbar ThemeThreeNavbar' style={{ backgroundColor: L1BgColor }}>


            <div className='ThemeThreeManageOnMobile'>
              {!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) && <div className="sidebar-menu-icon desktoThemeThreehamburger" onClick={() => { toggleMainMenu(); toggleClass(); }} >
                <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className={isActive ? 'hamburgerActiveClass' : 'hamburgerInactiveClass'}>
                  <MenuIcon />
                </IconButton>
              </div>}
              <div className='HeaderLogoThree'>
                <Link href="/" aria-label="logo" target={fetchAnchorValue(anchorLinksValue, "/")} className="MainLogoThree">
                  {mainLogo && <img src={getImageUrl(mainLogo, '999', 96, 36, "", false, props?.CONSTANTS)} alt="logo" width="96" height="36" />}
                </Link>
              </div>
            </div>



            <List orientation="horizontal"
              sx={{
                '--List-padding': '4px',
                '--List-gap': '0px',
                '--ListItem-paddingX': '7px',
                '--ListItem-paddingY': '0px',
                padding: "0px"
              }}
              itemType="http://www.schema.org/SiteNavigationElement"
              itemScope={true}
            >
              {pagetype == 'HOME' && getMenuData()} 
              {pagetype == 'ROS' && getMenuDataROS()}
              {/* {getMenuData()} */}
              {showSearch && <div className='themeThreeSearchIcon'>
                <Button className='ThemeThreeToggleButton' onClick={handleOpen}> {!Closebtn && <SearchIcon className='ThemeThreeSearchButton' onClick={() => showSearchBar()} />} {Closebtn && <SearchIcon className='ThemeThreeCloseSearchButton' onClick={() => closehandler()} />}</Button>
                {/* {Closebtn && <CloseIcon onClick={() => closehandler()} />} */}
                {/* <Button>{Closebtn && <SearchIcon onClick={() => closehandler()} />}</Button> */}


                {/* {(showSearch && SearchBar) &&
                  <div className='themeSearchMainWrap'>
                    <div className="search-main">
                      <div className="search" >
                      
                        <TextField
                          id=""
                          placeholder='Search'
                          type='text'
                          onKeyPress={(e) => handleKeyPress(e)}
                          onChange={e => setSearchValue(e.target.value)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <SearchIcon onClick={() => handleSearchClick(searchValue)} />
                              </InputAdornment>
                            )
                          }}
                        />
                      </div>
                    </div>
                  </div>
                } */}

                <div>


                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description" 
                  >
                    <Box sx={style} className="ThemeThreeModaleBox" >
                      {/* <Button className="ThemeThreeModaleBoxButton" onClick={handleClose}><CloseIcon/> </Button> */}
                      {/* <Typography id="modal-modal-title" variant="h6" component="h2" className='ModalThemeThreeTopic'>
           Search your topic
         </Typography> */}
                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>

                        {(showSearch && SearchBar) &&
                          <div className='themeSearchMainWrap'>
                            <Button className="ThemeThreeModaleBoxButton" onClick={handleClose}><CloseIcon /> </Button>
                            <div className="search-main">
                              <div className="search" >

                                <TextField
                                  id=""
                                  placeholder='Search'
                                  className='ThemeThreeSearchWrapWidth'
                                  type='text'
                                  onKeyPress={(e) => handleKeyPress(e)}
                                  onChange={e => setSearchValue(e.target.value)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <SearchIcon onClick={() => handleSearchClick(searchValue, hostId)} />
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        }
                      </Typography>
                    </Box>
                  </Modal>
                </div>
              </div>}
            </List>

            <div className="ThemeThreeLoginMainWrapper">
            { getLoginString() }
          </div>
          </div>
        </Box>
      </div>
    </CacheProvider>
  );
}